import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-746d318b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "legend-wrapper-div" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column invisible" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "flex-md-column text-center",
  style: {"padding-right":"20px"}
}
const _hoisted_5 = { style: {"margin-right":"8px"} }
const _hoisted_6 = {
  key: 0,
  class: "category-box upstream-color-cat-one",
  style: {"font-size":"small","margin-bottom":"0","margin-top":"0"}
}
const _hoisted_7 = {
  key: 1,
  class: "category-box upstream-color-cat-two",
  style: {"font-size":"small","margin-bottom":"0","margin-top":"0"}
}
const _hoisted_8 = {
  key: 2,
  class: "category-box upstream-color-cat-three",
  style: {"font-size":"small","margin-bottom":"0","margin-top":"0"}
}
const _hoisted_9 = {
  key: 3,
  class: "category-box upstream-color-cat-four",
  style: {"font-size":"small","margin-bottom":"0","margin-top":"0"}
}
const _hoisted_10 = {
  key: 4,
  class: "category-box upstream-color-cat-five",
  style: {"font-size":"small","margin-bottom":"0","margin-top":"0"}
}
const _hoisted_11 = {
  key: 5,
  class: "category-box upstream-color-cat-six",
  style: {"font-size":"small","margin-bottom":"0","margin-top":"0"}
}
const _hoisted_12 = {
  key: 6,
  class: "category-box upstream-color-cat-seven",
  style: {"font-size":"small","margin-bottom":"0","margin-top":"0"}
}
const _hoisted_13 = {
  key: 7,
  class: "category-box upstream-color-cat-eight",
  style: {"font-size":"small","margin-bottom":"0","margin-top":"0"}
}
const _hoisted_14 = {
  key: 8,
  class: "category-box downstream-color-not-included",
  style: {"font-size":"small","margin-bottom":"0","margin-top":"20px"}
}
const _hoisted_15 = {
  key: 1,
  class: "flex-md-column text-center",
  style: {"padding-right":"20px"}
}
const _hoisted_16 = {
  key: 0,
  class: "category-box downstream-color-cat-nine",
  style: {"font-size":"small","margin-bottom":"0","margin-top":"0"}
}
const _hoisted_17 = {
  key: 1,
  class: "category-box downstream-color-cat-ten",
  style: {"font-size":"small","margin-bottom":"0","margin-top":"0"}
}
const _hoisted_18 = {
  key: 2,
  class: "category-box downstream-color-cat-eleven",
  style: {"font-size":"small","margin-bottom":"0","margin-top":"0"}
}
const _hoisted_19 = {
  key: 3,
  class: "category-box downstream-color-cat-twelve",
  style: {"font-size":"small","margin-bottom":"0","margin-top":"0"}
}
const _hoisted_20 = {
  key: 4,
  class: "category-box downstream-color-cat-thirteen",
  style: {"font-size":"small","margin-bottom":"0","margin-top":"0"}
}
const _hoisted_21 = {
  key: 5,
  class: "category-box downstream-color-cat-fourteen",
  style: {"font-size":"small","margin-bottom":"0","margin-top":"0"}
}
const _hoisted_22 = {
  key: 6,
  class: "category-box downstream-color-cat-fifteen",
  style: {"font-size":"small","margin-bottom":"0","margin-top":"0"}
}
const _hoisted_23 = {
  key: 7,
  class: "category-box downstream-color-not-included",
  style: {"font-size":"small","margin-bottom":"0","margin-top":"20px"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column invisible" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (this.upstreamCategories.length > 0 || (this.selectedCategories.length === 0 && this.possibleUpstreamCategories.length > 0))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("h6", _hoisted_5, [
                _createVNode(_component_SimpleText, { "text-key": "calculate-forecast.category-graph.upstream-label" })
              ]),
              (_ctx.upstreamCategories.some(category => category === _ctx.constants.SCOPE3_CATEGORY_1) ||
             (this.selectedCategories.length === 0 && this.possibleUpstreamCategories.some(categoriesForSelect => categoriesForSelect.categoryId === _ctx.constants.SCOPE3_CATEGORY_1)))
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(this.getContentfulString('calculation.dropdown.possiblevalue.unit.category1')), 1))
                : _createCommentVNode("", true),
              (_ctx.upstreamCategories.some(category => category === _ctx.constants.SCOPE3_CATEGORY_2) ||
             (this.selectedCategories.length === 0 && this.possibleUpstreamCategories.some(categoriesForSelect => categoriesForSelect.categoryId === _ctx.constants.SCOPE3_CATEGORY_2)))
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(this.getContentfulString('calculation.dropdown.possiblevalue.unit.category2')), 1))
                : _createCommentVNode("", true),
              (_ctx.upstreamCategories.some(category => category === _ctx.constants.SCOPE3_CATEGORY_3) ||
             (this.selectedCategories.length === 0 && this.possibleUpstreamCategories.some(categoriesForSelect => categoriesForSelect.categoryId === _ctx.constants.SCOPE3_CATEGORY_3)))
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(this.getContentfulString('calculation.dropdown.possiblevalue.unit.category3')), 1))
                : _createCommentVNode("", true),
              (_ctx.upstreamCategories.some(category => category === _ctx.constants.SCOPE3_CATEGORY_4) ||
             (this.selectedCategories.length === 0 && this.possibleUpstreamCategories.some(categoriesForSelect => categoriesForSelect.categoryId === _ctx.constants.SCOPE3_CATEGORY_4)))
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(this.getContentfulString('calculation.dropdown.possiblevalue.unit.category4')), 1))
                : _createCommentVNode("", true),
              (_ctx.upstreamCategories.some(category => category === _ctx.constants.SCOPE3_CATEGORY_5) ||
             (this.selectedCategories.length === 0 && this.possibleUpstreamCategories.some(categoriesForSelect => categoriesForSelect.categoryId === _ctx.constants.SCOPE3_CATEGORY_5)))
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(this.getContentfulString('calculation.dropdown.possiblevalue.unit.category5')), 1))
                : _createCommentVNode("", true),
              (_ctx.upstreamCategories.some(category => category === _ctx.constants.SCOPE3_CATEGORY_6) ||
             (this.selectedCategories.length === 0 && this.possibleUpstreamCategories.some(categoriesForSelect => categoriesForSelect.categoryId === _ctx.constants.SCOPE3_CATEGORY_6)))
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(this.getContentfulString('calculation.dropdown.possiblevalue.unit.category6')), 1))
                : _createCommentVNode("", true),
              (_ctx.upstreamCategories.some(category => category === _ctx.constants.SCOPE3_CATEGORY_7) ||
             (this.selectedCategories.length === 0 && this.possibleUpstreamCategories.some(categoriesForSelect => categoriesForSelect.categoryId === _ctx.constants.SCOPE3_CATEGORY_7)))
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(this.getContentfulString('calculation.dropdown.possiblevalue.unit.category7')), 1))
                : _createCommentVNode("", true),
              (_ctx.upstreamCategories.some(category => category === _ctx.constants.SCOPE3_CATEGORY_8) ||
             (this.selectedCategories.length === 0 && this.possibleUpstreamCategories.some(categoriesForSelect => categoriesForSelect.categoryId === _ctx.constants.SCOPE3_CATEGORY_8)))
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(this.getContentfulString('calculation.dropdown.possiblevalue.unit.category8')), 1))
                : _createCommentVNode("", true),
              ((_ctx.downstreamCategories.length === 0 && this.upstreamCategories.length > 0) || (this.possibleDownstreamCategories.length === 0 && this.possibleUpstreamCategories.length > 0))
                ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(this.getContentfulString('forecast.columnchart.label.not-in-target-scope3')), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (this.downstreamCategories.length > 0 || (this.selectedCategories.length === 0 && this.possibleDownstreamCategories.length > 0))
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("h6", null, [
                _createVNode(_component_SimpleText, { "text-key": "calculate-forecast.category-graph.downstream-label" })
              ]),
              (_ctx.downstreamCategories.some(category => category === _ctx.constants.SCOPE3_CATEGORY_9) ||
             (this.selectedCategories.length === 0 && this.possibleDownstreamCategories.some(categoriesForSelect => categoriesForSelect.categoryId === _ctx.constants.SCOPE3_CATEGORY_9)))
                ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(this.getContentfulString('calculation.dropdown.possiblevalue.unit.category9')), 1))
                : _createCommentVNode("", true),
              (_ctx.downstreamCategories.some(category => category === _ctx.constants.SCOPE3_CATEGORY_10) ||
             (this.selectedCategories.length === 0 && this.possibleDownstreamCategories.some(categoriesForSelect => categoriesForSelect.categoryId === _ctx.constants.SCOPE3_CATEGORY_10)))
                ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(this.getContentfulString('calculation.dropdown.possiblevalue.unit.category10')), 1))
                : _createCommentVNode("", true),
              (_ctx.downstreamCategories.some(category => category === _ctx.constants.SCOPE3_CATEGORY_11) ||
             (this.selectedCategories.length === 0 && this.possibleDownstreamCategories.some(categoriesForSelect => categoriesForSelect.categoryId === _ctx.constants.SCOPE3_CATEGORY_11)))
                ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(this.getContentfulString('calculation.dropdown.possiblevalue.unit.category11')), 1))
                : _createCommentVNode("", true),
              (_ctx.downstreamCategories.some(category => category === _ctx.constants.SCOPE3_CATEGORY_12) ||
             (this.selectedCategories.length === 0 && this.possibleDownstreamCategories.some(categoriesForSelect => categoriesForSelect.categoryId === _ctx.constants.SCOPE3_CATEGORY_12)))
                ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(this.getContentfulString('calculation.dropdown.possiblevalue.unit.category12')), 1))
                : _createCommentVNode("", true),
              (_ctx.downstreamCategories.some(category => category === _ctx.constants.SCOPE3_CATEGORY_13) ||
             (this.selectedCategories.length === 0 && this.possibleDownstreamCategories.some(categoriesForSelect => categoriesForSelect.categoryId === _ctx.constants.SCOPE3_CATEGORY_13)))
                ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(this.getContentfulString('calculation.dropdown.possiblevalue.unit.category13')), 1))
                : _createCommentVNode("", true),
              (_ctx.downstreamCategories.some(category => category === _ctx.constants.SCOPE3_CATEGORY_14) ||
             (this.selectedCategories.length === 0 && this.possibleDownstreamCategories.some(categoriesForSelect => categoriesForSelect.categoryId === _ctx.constants.SCOPE3_CATEGORY_14)))
                ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(this.getContentfulString('calculation.dropdown.possiblevalue.unit.category14')), 1))
                : _createCommentVNode("", true),
              (_ctx.downstreamCategories.some(category => category === _ctx.constants.SCOPE3_CATEGORY_15) ||
             (this.selectedCategories.length === 0 && this.possibleDownstreamCategories.some(categoriesForSelect => categoriesForSelect.categoryId === _ctx.constants.SCOPE3_CATEGORY_15)))
                ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(this.getContentfulString('calculation.dropdown.possiblevalue.unit.category15')), 1))
                : _createCommentVNode("", true),
              (_ctx.downstreamCategories.length > 0 || (this.selectedCategories.length === 0 && this.possibleDownstreamCategories.length > 0))
                ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(this.getContentfulString('forecast.columnchart.label.not-in-target-scope3')), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _hoisted_24
      ])
    ])
  ]))
}